export interface ProductDeliveryItem {
  id: string;
  key: string;
  description: string;
  price: number;
  quantity: number;
  notes: string;
}
